let config = {
  emailjs: {
  }
};

export default config;
